// ─── CoreProviders ────────────────────────────────────────────────
// Le SEUL wrapper que chaque app monte à sa racine.
//   <CoreProviders app={{ id:'mop-my-inventory', nom:'My Inventory', version:'0.1.0' }}>
// Ordre imposé par les dépendances : Langue et Espace lisent Auth.
import React from 'react';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { AppProvider } from '../app/AppContext';
import { PreferencesUIProvider } from '../theme/PreferencesUI';
import { AuthProvider } from '../auth/AuthContext';
import { LangueProvider } from '../i18n/LangueContext';
import { EspaceProvider } from '../espace/EspaceContext';

export default function CoreProviders({ children, app, theme = 'auto', apresInscription }) {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider>
        <AppProvider app={app}>
          <PreferencesUIProvider themeParDefaut={theme}>
            <AuthProvider apresInscription={apresInscription}>
              <LangueProvider>
                <EspaceProvider>
                  {children}
                </EspaceProvider>
              </LangueProvider>
            </AuthProvider>
          </PreferencesUIProvider>
        </AppProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}
